var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotificacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3d444c;stroke:#3d444c;stroke-miterlimit:10;stroke-width:.49px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.84,23.34c-2.34-1.98-4.01-4.87-4.01-7.93v-4.53C26.83,5.11,22.14,.42,16.38,.42S5.93,5.11,5.93,10.87v4.53c0,3.06-2.46,5.96-4.81,7.94-.5,.43-.78,1.05-.78,1.7,0,1.23,1,2.24,2.24,2.24H11.23c.37,2.53,2.52,4.48,5.15,4.48s4.78-1.95,5.15-4.48h7.87c1.24,0,2.24-1,2.24-2.24,0-.66-.29-1.27-.8-1.71Zm-14.46,6.94c-1.8,0-3.31-1.28-3.66-2.99h7.31c-.35,1.7-1.85,2.99-3.66,2.99Zm13.02-4.48H2.57c-.41,0-.75-.33-.75-.75,0-.22,.1-.43,.27-.57,2.68-2.26,5.33-5.57,5.33-9.07v-4.53C7.43,5.93,11.44,1.91,16.38,1.91s8.96,4.02,8.96,8.96v4.53c0,3.5,1.87,6.81,4.55,9.08,.17,.14,.26,.35,.26,.57,0,.41-.33,.75-.75,.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificacion);
export default __webpack_public_path__ + "static/media/icon_notificacion.6c9c8d7dd0018cdabf634169b1693dd8.svg";
export { ForwardRef as ReactComponent };